/**
 * The support route paths, in a module with no components — Task 13.2.
 *
 * Separated from `routes.tsx` because the queue and detail views link to each other: with the builders in the
 * route tree, `SupportQueue.tsx` would import `routes.tsx` and `routes.tsx` would import it back. A path is
 * data, so it belongs where both can reach it.
 *
 * These are browser paths. The API paths are in `api.ts`, and they are deliberately not derived from each
 * other: `/support/:publicId` and `/api/admin/support-requests/:publicId` are two different contracts that
 * happen to share an identifier.
 */
export const supportRoutePath = '/support';

export const supportRequestPath = (publicId: string): string =>
  `${supportRoutePath}/${encodeURIComponent(publicId)}`;
